import { cva, VariantProps } from 'class-variance-authority';

export const paginationStyles = cva(
  'flex px-24 py-16 justify-between items-center',
  {
    variants: {
      variant: {
        bordered: 'border border-t-0 border-grayscale100 rounded-b-8',
        borderless: '',
      },
    },
    defaultVariants: {
      variant: 'bordered',
    },
  },
);

export type PaginationStyles = VariantProps<typeof paginationStyles>;
